import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Providers/AuthProvider';
import { Loading } from './Loading';

export const ProtectedRoute = ({ children, allowedRoles }) => {
    const { isAuthenticated, token, role, isLoading, hasRole } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return <Loading />;
    }

    if (!isAuthenticated || !token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && (Array.isArray(allowedRoles) ? allowedRoles.length > 0 : Boolean(allowedRoles))) {
        if (!hasRole(allowedRoles)) {
            const normalizedRole = (role || '').toString().trim().toLowerCase();
            if (normalizedRole === 'sound_operator') {
                return <Navigate to="/admin/playlist/cabina" replace />;
            }
            return <Navigate to="/admin/dashboard" replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
